/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { ArrayUtil } from '@cedalo/util';
import VersionUpgrade from '@mui/icons-material/esm/Warning';
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import DialogButton from '../../ui/utils/DialogButton';

export const ConfirmImportDialog = ({ children, onCancel, onConfirm, machines }) => {
	return (
		<Dialog fullWidth open maxWidth="sm">
			<DialogTitle>
				<FormattedMessage id="Import.Dialog.Title" defaultMessage="Import" />
			</DialogTitle>
			<DialogContent
				style={{
					margin: '16px'
				}}
			>
				<Grid container direction="column">
					<Grid item alignItems="center" container direction="row" spacing={1}>
						<Grid item>
							<VersionUpgrade color="error" />
						</Grid>
						<Grid item>
							<Typography variant="subtitle1" color="textPrimary">
								<FormattedMessage
									id="Import.Confirmation.Message"
									defaultMessage="Following machines and streams will be overwritten."
								/>
							</Typography>
						</Grid>
					</Grid>
					<Paper
						style={{
							margin: '16px 0px 8px',
							padding: '8px 24px 16px'
						}}
					>
						<Grid item>
							<Typography style={{ padding: '16px 0px' }} variant="h6" color="textPrimary">
								<FormattedMessage id="Import.List.Machines.Title" defaultMessage="Machines" />
							</Typography>
						</Grid>
						<Grid item container spacing={1} alignItems="center">
							{ArrayUtil.intersperse(
								machines.map(({ newName, id }) => (
									<Grid item sm={12} key={id}>
										<Typography variant="subtitle1">{newName}</Typography>
									</Grid>
								)),
								(index) => (
									<Grid item key={`sep-${index}`} sm={12}>
										<Divider />
									</Grid>
								)
							)}
						</Grid>
					</Paper>
				</Grid>
			</DialogContent>
			{children}
			<Divider />
			<DialogActions>
				<DialogButton margin onClick={onCancel}>
					<FormattedMessage id="Cancel" defaultMessage="Cancel" />
				</DialogButton>
				<DialogButton margin onClick={onConfirm}>
					<FormattedMessage id="Import.Button.Import" defaultMessage="Import" />
				</DialogButton>
			</DialogActions>
		</Dialog>
	);
};
